import {
	createColumnHelper as createTanstackColumnHelper,
	type RowData,
} from "@tanstack/react-table";
import type { DataTableFeatures } from "./features";

/**
 * TanStack's column helper with the DataTable's feature set already bound, so a table
 * config names only its row type: `createColumnHelper<ArticleListItem>()`.
 */
export function createColumnHelper<TData extends RowData>() {
	return createTanstackColumnHelper<DataTableFeatures, TData>();
}
